import React from 'react';

interface Tab {
  key: string;
  label: string;
  count: number;
}

/** 列头配色跟随所在栏的边框色：实时告警是红框栏，其余是紫框栏 */
type Tone = 'violet' | 'red';

const TONE: Record<Tone, { head: string; active: string }> = {
  violet: {
    head: 'bg-violet-50 border-violet-200',
    active: 'font-semibold text-violet-600 border-violet-600',
  },
  red: {
    head: 'bg-red-50 border-red-200',
    active: 'font-semibold text-red-600 border-red-600',
  },
};

interface ColumnHeaderProps {
  tabs: Tab[];
  activeKey: string;
  onChange: (key: string) => void;
  extra?: React.ReactNode;
  tone?: Tone;
}

const ColumnHeader: React.FC<ColumnHeaderProps> = ({
  tabs,
  activeKey,
  onChange,
  extra,
  tone = 'violet',
}) => {
  const style = TONE[tone];

  return (
    <div
      className={`flex flex-wrap items-center gap-x-3 gap-y-1 px-4 py-3 rounded-t-lg border-b ${style.head}`}
    >
      <div className="flex flex-wrap items-center gap-x-4 gap-y-1">
        {tabs.map((tab) => {
          const isActive = tab.key === activeKey;
          return (
            <button
              key={tab.key}
              type="button"
              onClick={() => onChange(tab.key)}
              className={`text-sm whitespace-nowrap pb-1 border-b-2 transition-colors ${
                isActive ? style.active : 'text-gray-500 border-transparent hover:text-gray-700'
              }`}
            >
              {tab.label} · {tab.count}
            </button>
          );
        })}
      </div>
      {extra && <div className="ml-auto shrink-0 text-xs text-gray-500">{extra}</div>}
    </div>
  );
};

export default ColumnHeader;
